import {
  AppShell,
  Group,
  LoadingOverlay,
  Skeleton,
  Stack,
} from "@mantine/core";
import "./LayoutStyles.css";
import { useUIStore } from "../stores/UIStore";
import { useEffect, useMemo } from "react";
import Navbar from "./Navbar/Navbar";
import Header from "./Header/Header";
import { Outlet, useMatches, useNavigate } from "react-router-dom";
import VersionController from "../components/View/VersionController";
import { useProfileStore, useSessionStore } from "../stores/UserStore";
import LinkedinCheckpoint from "../pages/protected/senders/linkedin/LinkedinCheckpoint";
import HeaderMobile from "./Header/mobile/HeaderMobile";

export function MainLayout() {
  const navbarClosed = useUIStore((s) => s.navbarClosed);
  const mainLoading = useUIStore((s) => s.mainLoading);
  const windowLoading = useUIStore((s) => s.windowLoading);
  const unswitchedProfile = useProfileStore((s) => s.unswitchedProfile);
  const userSwitch = useSessionStore((state) => state.user_switch);

  // Page Title
  const matches = useMatches();
  // Get closest route with handle.name
  const matchWithName = [...matches].reverse().find((m) => m.handle?.name);

  document.title = `${matchWithName?.handle?.name} - ${
    useSessionStore.getState().reseller?.name || ""
  }`;

  const disableNav = useMemo(() => {
    const urlParams = new URLSearchParams(window.location.search);
    return (
      localStorage.getItem("disable_nav") === "true" ||
      urlParams.get("disableNav") === "true"
    );
  }, []);

  const disableHeading = useMemo(() => {
    const urlParams = new URLSearchParams(window.location.search);
    return (
      localStorage.getItem("disable_heading") === "true" ||
      urlParams.get("disableHeading") === "true"
    );
  }, []);

  const isMobile = useMemo(() => {
    const urlParams = new URLSearchParams(window.location.search);
    return (
      localStorage.getItem("disable_mobile") !== "true" &&
      urlParams.get("disableMobile") !== "true" &&
      window.innerWidth < 768
    );
  }, []);

  const navigate = useNavigate();
  useEffect(() => {
    if (isMobile) {
      const params = window.location.search; // keeps all query params
      const hash = window.location.hash;
      navigate(`/leads-tracking${params}${hash}`);
    }
  }, [isMobile]);

  return (
    <AppShell
      navbar={{
        width: navbarClosed ? 75 : 240,
        collapsed: {
          desktop: disableNav || isMobile,
          mobile: disableNav || isMobile,
        },
        breakpoint: "xs",
      }}
      padding={0}
      styles={{
        navbar: {
          boxShadow: "none",
        },
      }}
    >
      <LoadingOverlay
        visible={mainLoading}
        zIndex={1000}
        overlayProps={{ blur: 2 }}
        w={"100%"}
        h={"100%"}
      />

      {!isMobile && <LinkedinCheckpoint />}

      {!disableNav && !isMobile && (
        <AppShell.Navbar
          style={{ border: 0, zIndex: 120 }}
          bg={"var(--mantine-color-primary-2)"}
        >
          <Navbar closed={navbarClosed} />
        </AppShell.Navbar>
      )}
      <AppShell.Main
        component={Stack}
        bg={"var(--mantine-color-primary-2)"}
        gap={0}
      >
        {!disableHeading && !isMobile && (
          <AppShell.Header
            style={{ border: 0, zIndex: 120, borderRadius: 12 }}
            pos={"sticky"}
          >
            <Header />
          </AppShell.Header>
        )}

        {!disableHeading && isMobile && (
          <AppShell.Header
            style={{ border: 0, zIndex: 120, borderRadius: 12 }}
            pos={"sticky"}
          >
            <HeaderMobile />
          </AppShell.Header>
        )}

        {windowLoading ? (
          <Skeleton
            w={"100%"}
            h={"88vh"}
            maw={"96%"}
            mx={"auto"}
            radius={"lg"}
          />
        ) : (
          <Outlet key={userSwitch?.id || unswitchedProfile?.id} />
        )}
        <VersionController />
      </AppShell.Main>
    </AppShell>
  );
}
